import request from "@helpers/request"


function fetchWorkspaces(config) {
    return request.forBaseUrl()
        .withHeaders({ "Content-Type": "application/json" })
        .build().get(`/v1/workspace`, {}, { ...config });
}

function createWorkspace(params, config) {
    return request.forBaseUrl()
        .withHeaders({ "Content-Type": "application/json" })
        .build().post(`/v1/workspace`, params, { ...config });
}

function deleteWorkspace(id, config) {
    return request.forBaseUrl()
        .withHeaders({ "Content-Type": "application/json" })
        .build().delete(`/v1/workspace`, { _id: id }, { ...config });
}


const workspaceService = {
    fetchWorkspaces,
    createWorkspace,
    deleteWorkspace,
}

export default workspaceService